import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MerchantServiceService {
  rootURL = 'https://backend.bogo-plus.com/en/api';

  offers_arr_beh = new BehaviorSubject({});
  claims_arr_beh = new BehaviorSubject({});
  branches_beh = new BehaviorSubject([]);
  private _provider;

  constructor(public http: HttpClient) {
    console.log('Hello MerchantProvProvider Provider');
  }

  public set provider(provider) {
    this._provider = provider;
  }

  public get provider() {
    return this._provider;
  }

  login(username, password) {
    return this.http.post(`${this.rootURL}/users/email_password_login/`, {
      email: username,
      password: password,
    });
  }

  offers(brand_id: any) {
    return this.http.get(
      `${this.rootURL}/offer/?page_size=15&brand=${brand_id ? brand_id : ''}`
    );
  }

  getClaims() {
    return this.http.get(`${this.rootURL}/claim-request/?page_size=15`);
  }

  getClaimsFilter(dateFrom, dateTo, branch) {
    console.log('getClaimsFilter variable: ', dateFrom, dateTo, branch);
    if (!dateFrom && !dateTo) {
      return this.http.get(
        `${this.rootURL}/claim-request/?branch=${branch}&page_size=15`
      );
    } else if (!branch && !dateTo && dateFrom) {
      return this.http.get(
        `${this.rootURL}/claim-request/?start_date=${dateFrom}&page_size=15`
      );
    } else if (!branch && dateFrom && dateTo) {
      return this.http.get(
        `${this.rootURL}/claim-request/?start_date=${dateFrom}&end_date=${dateTo}&page_size=15`
      );
    } else if (branch && dateFrom && !dateTo) {
      return this.http.get(
        `${this.rootURL}/claim-request/?start_date=${dateFrom}&branch=${branch}&page_size=15`
      );
    } else if (branch && dateFrom && dateTo) {
      return this.http.get(
        `${this.rootURL}/claim-request/?start_date=${dateFrom}&end_date=${dateTo}&branch=${branch}&page_size=15`
      );
    }
  }

  getB2BClaimsFilter(dateFrom, dateTo, branch) {
    console.log('getClaimsFilter variable: ', dateFrom, dateTo, branch);
    if (!dateFrom && !dateTo) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/?branch=${branch}&page_size=15`
      );
    } else if (!branch && !dateTo && dateFrom) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/?start_date=${dateFrom}&page_size=15`
      );
    } else if (!branch && dateFrom && dateTo) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/?start_date=${dateFrom}&end_date=${dateTo}&page_size=15`
      );
    } else if (branch && dateFrom && !dateTo) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/?start_date=${dateFrom}&branch=${branch}&page_size=15`
      );
    } else if (branch && dateFrom && dateTo) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/?start_date=${dateFrom}&end_date=${dateTo}&branch=${branch}&page_size=15`
      );
    }
  }

  getItemsPaginate(page_url, pageNo) {
    let urlTest;
    if (page_url.includes('?')) {
    } else {
      urlTest = page_url + '?';
      page_url = urlTest;
    }
    return this.http.get(`${page_url}&page=${pageNo}`);
  }

  generatePin() {
    return this.http.post(`${this.rootURL}/api-v1/GenerateBranchPin/`, {});
  }

  getB2BClaims() {
    return this.http.get(`${this.rootURL}/redeemed-coupons/?page_size=15`);
  }

  B2B(offer_key) {
    return this.http.post(`${this.rootURL}/offer/redeem_coupon/`, {
      coupon: offer_key,
    });
  }

  B2C(offer_key) {
    return this.http.put(`${this.rootURL}/claim-request/${offer_key}/`, {
      is_claimed: true,
    });
  }

  exportClaims(dateFrom, dateTo, branch) {
    if (!dateFrom && !dateTo) {
      return this.http.get(
        `${this.rootURL}/claim-request/export_claims/?branch=${branch}`
      );
    } else if (!branch && !dateTo && dateFrom) {
      return this.http.get(
        `${this.rootURL}/claim-request/export_claims/?start_date=${dateFrom}`
      );
    } else if (!branch && dateFrom && dateTo) {
      return this.http.get(
        `${this.rootURL}/claim-request/export_claims/?start_date=${dateFrom}&end_date=${dateTo}`
      );
    } else if (branch && dateFrom && !dateTo) {
      return this.http.get(
        `${this.rootURL}/claim-request/export_claims/?start_date=${dateFrom}&branch=${branch}`
      );
    } else if (branch && dateFrom && dateTo) {
      return this.http.get(
        `${this.rootURL}/claim-request/export_claims/?start_date=${dateFrom}&end_date=${dateTo}&branch=${branch}`
      );
    }
  }

  exportCoupons(dateFrom, dateTo, branch) {
    if (!dateFrom && !dateTo) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/export_redeems/?branch=${branch}`
      );
    } else if (!branch && !dateTo && dateFrom) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/export_redeems/?start_date=${dateFrom}`
      );
    } else if (!branch && dateFrom && dateTo) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/export_redeems/?start_date=${dateFrom}&end_date=${dateTo}`
      );
    } else if (branch && dateFrom && !dateTo) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/export_redeems/?start_date=${dateFrom}&branch=${branch}`
      );
    } else if (branch && dateFrom && dateTo) {
      return this.http.get(
        `${this.rootURL}/redeemed-coupons/export_redeems/?start_date=${dateFrom}&end_date=${dateTo}&branch=${branch}`
      );
    }
  }

  getAllOwnerBranshes(brand_id: number) {
    return this.http.get(
      `${this.rootURL}/branch/?brand=${brand_id ? brand_id : ''}&page_size=500`
    );
  }

  getPaginateBranches(url) {
    return this.http.get(url);
  }

  getProviders() {
    return this.http.get(
      `${this.rootURL}/api-v2/providers/?page=1&page_size=50`
    );
  }

  b2bClaim(promocode, provider) {
    return this.http.post(`${this.rootURL}/api-v2/b2b-claim/`, {
      promocode,
      provider,
    });
  }

  getMe() {
    return this.http.get(`${this.rootURL}/users/states/`);
  }
}
